export const GRADE_UNICA = 'GRADE_UNICA';
export const GRADE_MULTIPLA = 'GRADE_MULTIPLA';
